import CreateRetail from "components/ManageRetail/CreateRetail";
import NotFooterLayout from "layouts/NotFooterLayout";
import { useSearchParams } from "react-router-dom";

function CreateRetailPage() {
  const [searchParams] = useSearchParams();
  const telephone = searchParams.get("telephone");
  console.log(telephone);
  return (
    <>   
      <NotFooterLayout namePage="เพิ่มลูกค้า"  >
        <div className="layout-content">
          <CreateRetail telephone={telephone ?? ''}/>
        </div>
      </NotFooterLayout>
    </>
  );
}

export default CreateRetailPage;
